<template>
    <div class="main__assessment__box__wrapper">
        <div class="common__page__box main__learner__assessments__page">
            <div class="rlms-container">
                <section class="learner__assessments__filter__box">
                    <div class="back__btn">
                        <RouterLink
                            :to="{ name: 'LearnerDashboard', params: { organization: organizationId, learner: learnerId } }">
                            <span class="btn__icon">
                                <img :src="backBtnIcon" />
                            </span>
                            <span class="btn__text">Back</span>
                        </RouterLink>
                    </div>
                    <div class="main__title">
                        <h3 class="title">Results</h3>
                    </div>
                    <div class="recycle__bin__btn" v-if="canConductAssessment">
                        <a href="javascript:void(0);" v-if="learner?.bin_count > 0" @click="binAssessmentModal = true">
                            <span class="btn__icon"><img :src="removeIcon1" /></span>
                            <span class="btn__text">Recycle Bin</span>
                        </a>
                    </div>
                    <div class="purple__fill__btn">
                        <a href="javascript:void(0)" id="create_assessment"
                            v-if="learner?.subscriptions_details && !learner?.subscriptions_details.is_expired && canConductAssessment"
                            @click="createAssessment">Create New
                            Assessment</a>
                    </div>
                </section>
                <div class="rlms-w-100" :class="{
                    'main__learner__assessments__data__box learners__assessment__widget': !isMobile,
                    'rlms-flex rlms-flex-col rlms-gap-30': isMobile
                }">
                    <template v-if="learner?.subscriptionid">
                        <template v-if="assessments?.length > 0">
                            <template v-if="isMobile">
                                <div class="mobile__learners__assessment__widget for__mobile">
                                    <div class="mobile__learner__assessment__list__wrapper"
                                        v-for="(assessment) in assessments" :key="assessment.id">
                                        <div class="learner__assessment__box__item">
                                            <div class="learner__assessment__header">
                                                <div class="date__assessment__label">
                                                    <span class="date__text">{{ formatDate(assessment?.created_at)
                                                        }}</span>
                                                    <span class="text">Assessment #{{ assessment?.serialno }}</span>
                                                </div>
                                                <div class="learner__user__progress__bar">
                                                    <div class="progress__bar__title">
                                                        <label class="progress__label"></label>
                                                        <span class="progress__percent">({{
                                                            assessment?.stats?.total_score
                                                            }}/100)</span>
                                                    </div>
                                                </div>
                                                <div class="learner__user__progress__bar">
                                                    <div class="progress__bar__title">
                                                        <label class="progress__label">Progress</label>
                                                        <span class="progress__percent">{{
                                                            assessment?.stats?.total_percentage }}%</span>
                                                    </div>
                                                    <div class="learner__progress">
                                                        <div class="default__progressbar">
                                                            <span class="progressbar__filler"
                                                                :style="{ width: `${assessment?.stats?.total_percentage}%` }"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="divider__sepline"></div>
                                            <div class="learner__options__wrap">
                                                <div class="link__btn">
                                                    <RouterLink
                                                        :to="`/organizations/${organizationId}/learners/${learnerId}/assessments/${assessment.id}`"
                                                        class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer">
                                                        <span class="link__icon">
                                                            <img :src="blueEdit">
                                                        </span>
                                                        <span class="link__text">View</span>
                                                    </RouterLink>
                                                </div>
                                                <div class="link__btn">
                                                    <a href="javascript:void(0)" class="delete_assessment"
                                                        @click="deleteAssessment(assessment.id, 0, assessment?.can_edit)">
                                                        <span class="link__icon"><img :src="blueTrash"></span>
                                                        <span class="link__text">Remove</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="learners__assessment__table__box__wrapper rlms-mb-6">
                                    <div class="head__title__box">
                                        <div class="head__title head__index__number">#</div>
                                        <div class="head__title head__date">Date</div>
                                        <div class="head__title head__score__assessment">Assessment Score</div>
                                        <div class="head__title head__progress">Completion Progress</div>
                                        <div class="head__title head__action">Action</div>
                                    </div>
                                    <div class="divider__sepline"></div>
                                    <div class="learners__assessment__card__box" style="height: auto;">
                                        <div class="learners__assessment__item"
                                            v-for="(assessment) in assessments" :key="assessment.id">
                                            <div class="learners__assessment__data learners__index__number">
                                                <span class="index__number color1">{{ assessment?.serialno }}</span>
                                            </div>
                                            <div class="learners__assessment__data learners__date">
                                                {{ formatDate(assessment?.created_at) }}
                                            </div>
                                            <div class="learners__assessment__data learners__score__assessment">
                                                <span class="score__label">{{ assessment?.stats?.total_score
                                                    }}/100</span>
                                            </div>
                                            <AssessmentProgressBar
                                                :overallProgress="assessment?.stats?.total_percentage"
                                                :groups="assessment?.stats?.group_scores" />
                                            <div class="learners__assessment__data learners__action">
                                                <div class="learners__btn__group">
                                                    <div class="action__default__btn">
                                                        <RouterLink
                                                            :to="`/organizations/${organizationId}/learners/${learnerId}/assessments/${assessment.id}`"
                                                            class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer">
                                                            <span class="btn__icon">
                                                                <img :src="blueEdit">
                                                            </span>
                                                            <span class="btn__text">View</span>
                                                        </RouterLink>
                                                    </div>
                                                    <div class="action__default__btn">
                                                        <a href="javascript:void(0)" class="delete_assessment"
                                                            @click="deleteAssessment(assessment.id, 0, assessment?.can_edit)">
                                                            <span class="btn__icon"><img :src="blueTrash"></span>
                                                            <span class="btn__text">Remove</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <div class="no__learner__assessment__block rlms-text-center">
                                <div class="learner_assessment_delete_btn_wrapper rlms-w-100">
                                    <h3 class="title rlms-mb-3">You Have No Results Yet</h3>
                                    <div class="ladb rlms-mx-auto" v-if="learner?.bin_count > 0"
                                        @click="binAssessmentModal = true" style="width: 140px;">
                                        <a href="javascript:void(0)" class="rlms-flex rlms-justify-between">
                                            <span class="btn__icon">
                                                <img :src="removeIcon1" />
                                            </span>
                                            <span class="btn__text">Recycle Bin</span>
                                        </a>
                                    </div>
                                    <template v-else>
                                        <div class="subtitle rlms-mb-3">
                                            Please click the below button for adding the assessment
                                        </div>
                                        <div class="purple__fill__btn">
                                            <a href="javascript:void(0)" id="create_assessment"
                                                v-if="learner?.subscriptions_details && !learner?.subscriptions_details.is_expired"
                                                @click="createAssessment">Create New
                                                Assessment</a>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                        <paginate v-model="page" :page-count="totalPages" :margin-pages="2" :prev-text="'<'"
                            :next-text="'>'" :container-class="'pagination'" :page-class="'page-item'"
                            :active-class="'active-page'" v-if="totalItems > 0" />
                    </template>
                    <div class="no__learner__assessment__block" v-else>
                        <div class="inner__content__block" v-if="learner">
                            <div class="title__block__wrap">
                                <h4 class="title">
                                    {{ learner.subscriptionid == 0 ? `Learner Subscription Has Expired` : `Learner Has
                                    No Subscription` }}
                                </h4>
                                <span class="subtitle">
                                    Please click the below button for adding the Subscription
                                </span>
                            </div>

                            <div class="purple__solid__btn">
                                <RouterLink :to="`/organizations/${learner.organization_id}/overview`">
                                    View Organization
                                </RouterLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <BinAssessmentsModal v-if="binAssessmentModal" @close="binAssessmentModal = false;" @saved="init()"
        :organizationId="organizationId" :learnerId="learner?.id" />
</template>

<script setup>
import api from '@/services/axios';
import { handleError } from '@/utils/handleError';
import { useLoaderStore } from '@/stores/loader';
import { ref, onMounted, watch, onUnmounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { formatDate } from '@/utils/format-helpers';
import AssessmentProgressBar from '@/components/assesments/AssessmentProgressBar.vue';
import paginate from 'vuejs-paginate-next';
import BinAssessmentsModal from '@/components/BinAssessmentsModal.vue';
import confirmationIcon from '@/assets/images/confirmation.png';
import { showConfirmDialog, showDialog, showToast } from '@/utils/swal';
import backBtnIcon from '@/assets/images/back-btn-icon.png'
import removeIcon1 from '@/assets/images/remove-icon1.png'
import blueEdit from '@/assets/images/see-icon.png'
import blueTrash from '@/assets/images/blue-trash.svg'
import { authrizedPermissions } from '@/utils/permissions';

const route = useRoute();
const organizationId = ref(Number(route.params.organization ?? 0));
const learnerId = ref(Number(route.params.learner ?? 0));

const loader = useLoaderStore();

// State
const learner = ref(null)
const organization = ref(null)
const assessments = ref(null)
const page = ref(1);
const perPage = ref(10);
const totalPages = ref(1);
const totalItems = ref(0);
const binAssessmentModal = ref(false);

const screenWidth = ref(window.innerWidth);
const isMobile = computed(() => screenWidth.value < 768);
const updateWidth = () => {
    screenWidth.value = window.innerWidth;
};

onMounted(() => {
    window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
    window.removeEventListener('resize', updateWidth);
});

const fetchAssessments = async () => {
    try {
        loader.show();
        const { data } = await api.get(`/organizations/${organizationId.value}/assessments`, {
            params: {
                learner_id: learnerId.value,
                page: page.value,
                per_page: perPage.value,
                status: 1
            }
        });

        learner.value = data?.data?.learner
        organization.value = data?.data?.organization
        assessments.value = data?.data?.assessments?.data

        // Optional: store pagination meta if needed
        totalPages.value = data.data.assessments.last_page;
        totalItems.value = data.data.assessments.total;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

const init = async () => {
    page.value = 1;
    await fetchAssessments();
}

const createAssessment = async () => {
    try {
        loader.show();
        await api.post(`/organizations/${organizationId.value}/assessments`, {
            learner_id: learnerId.value
        });

        showToast({
            icon: 'success',
            title: 'Great! ',
            text: 'Assessment created successfully.',
        });

        init();
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

const deleteAssessment = async (assessment, status, canEdit = true) => {
    if (!canEdit) {
        let message = `You don’t have permission perform this action.`;

        if (learner.value?.is_administrator) {
            message = `You don’t have permission to move this assessment to the bin because it was created before you were granted administrator access.`;
        } else if (learner.value?.is_authorized_user) {
            if (learner.value?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `You don’t have permission to move this assessment to the bin because it was created before you were granted group access.`;
            } else if (!learner.value?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `Assessment available to you through group access. You don’t have permission perform this action.`;
            }
        }

        showDialog({ icon: 'warning', html: message });
        return;
    }

    const result = await showConfirmDialog({
        title: 'Are you sure?',
        html: '<p id="text-message">Are you sure?</p><span class="rlms-text-danger-500" id="delete-confirm"> Would you like to move this assessment to the recycle bin?</span>',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Confirm',
        imageUrl: confirmationIcon,
    });

    if (result.isConfirmed) {
        try {
            loader.show();

            await api.put(`/organizations/${organizationId.value}/assessments/${assessment}`, {
                status
            });

            showToast({
                icon: 'success',
                title: 'Deleted! ',
                text: 'Assessment moved to the recycle bin. You can restore it anytime.',
            });

            init();
        } catch (error) {
            handleError(error);
        } finally {
            loader.hide();
        }
    }
};

watch(route, ({ params }) => {
    organizationId.value = params.organization;
    learnerId.value = params.learner;

    init()
}, { deep: true });

watch(page, () => {
    fetchAssessments();
});

onMounted(async () => {
    await init();
});

const canConductAssessment = computed(() => {
    return (learner.value?.is_owner || learner.value?.is_administrator ||
        (learner.value?.is_authorized_user && learner.value?.permissions?.[authrizedPermissions.conduct_view_assessments])
    )
});
</script>
